var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as dataCollection from '@wix/ambassador-data-v2-data-collection/http';
var HttpTransport = /** @class */ (function () {
    function HttpTransport(httpClient, signedInstance, options) {
        this.httpClient = httpClient;
        this.signedInstance = signedInstance;
        this.baseUrl = getBaseUrl(options);
    }
    HttpTransport.prototype._call = function (request) {
        var _this = this;
        return this.httpClient.request(function (params) {
            var interceptedRequest = request(params);
            var url = _this.baseUrl + trimStart(interceptedRequest.url, '/_api/cloud-data');
            return __assign(__assign({}, interceptedRequest), { url: url, headers: __assign(__assign({}, interceptedRequest.headers), { authorization: _this.signedInstance }) });
        }, { signedInstance: this.signedInstance })
            .then(function (resp) { return resp.data; });
    };
    HttpTransport.prototype.create = function (req) {
        return this._call(dataCollection.createDataCollection(req));
    };
    HttpTransport.prototype.delete = function (req) {
        return this._call(dataCollection.deleteDataCollection(req));
    };
    HttpTransport.prototype.get = function (req) {
        return this._call(dataCollection.getDataCollection(req));
    };
    HttpTransport.prototype.getBulk = function (req) {
        return this._call(dataCollection.bulkGetDataCollections(req));
    };
    HttpTransport.prototype.list = function (req) {
        return this._call(dataCollection.listDataCollections(req));
    };
    HttpTransport.prototype.update = function (req) {
        return this._call(dataCollection.updateDataCollection(req));
    };
    HttpTransport.prototype.createField = function (req) {
        return this._call(dataCollection.createDataCollectionField(req));
    };
    HttpTransport.prototype.updateField = function (req) {
        return this._call(dataCollection.updateDataCollectionField(req));
    };
    HttpTransport.prototype.deleteField = function (req) {
        return this._call(dataCollection.deleteDataCollectionField(req));
    };
    return HttpTransport;
}());
export default HttpTransport;
function trimEnd(str, suffix) {
    return str.endsWith(suffix) ? str.substring(0, str.length - suffix.length) : str;
}
function trimStart(str, prefix) {
    return str.startsWith(prefix) ? str.substring(prefix.length) : str;
}
function getBaseUrl(options) {
    var baseUrl = options === null || options === void 0 ? void 0 : options.baseUrl;
    if (!baseUrl) {
        return 'https://cloud-data.wix-code.com';
    }
    // frontend has places where it gives '/_api/cloud-data/v1/schemas' as baseUrl
    baseUrl = trimEnd(baseUrl, '/');
    baseUrl = trimEnd(baseUrl, '/v1/schemas');
    return baseUrl;
}
//# sourceMappingURL=V2HttpClient.js.map